module.exports = __webpack_public_path__ + "img/mmi-about-photo-team-mark.01671e1d.png";